import React, { useCallback, useState } from "react";
import Dropdown, { UncontrolledDropdownProps, DropdownProps } from "reactstrap/lib/Dropdown";

const UncontrolledDropdown: React.FC<UncontrolledDropdownProps> = function ({ defaultOpen, ...props }) {
   const [isOpen, setIsOpen] = useState(defaultOpen || false);

   const toggle: DropdownProps["toggle"] = useCallback(ev => {
      const newIsOpen = !isOpen;
      setIsOpen(newIsOpen);
      if (props.onToggle) {
         props.onToggle(ev, newIsOpen);
      }
   }, [props.onToggle, isOpen]);

   return <Dropdown isOpen={isOpen} toggle={toggle} {...props} />;
};


export default UncontrolledDropdown;